<template>
  <svg class="svg-icon" :class="[name, modifierChecked, modifierClass]">
    <use :xlink:href="href" />
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon',
  props: {
    modifier: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: true
    },
    name: {
      type: String
    },
    id: {
      type: String
    }
  },
  data: function () {
    return {
      block: 'svg-icon--'
    }
  },
  computed: {
    modifierClass () {
      if (this.modifier.length) {
        return this.modifier.split(' ').map(m => this.block + m).join(' ')
      } else {
        return ''
      }
    },
    modifierChecked () {
      return this.checked ? this.block + 'checked' : ''
    },
    href () {
      let path = process.env.NODE_ENV === 'development' ? '/static/svg-sprite.svg#' : '/themes/custom/tryg/dist/svg/svg-sprite.svg#'
      if (this.checked) {
        return path + this.id
      } else {
        return path
      }
    }
  }
}
</script>

<style lang="scss">
.button.has-check-icon {
  .svg-icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    transition: fill .4s cubic-bezier(1, 0, 0, 1);
    transition-property: fill, background-color, border-color;
  }
  .svg-icon--radio {
    border:0.066rem solid currentColor;
    border-radius:50%;
  }
  .svg-icon--checkbox {
    border:0.066rem solid currentColor;
  }
  .svg-icon--radio,
  .svg-icon--checkbox {
    margin:0 .5rem;
  }

  .svg-icon:not(.svg-icon--checked) {
    background: transparent !important;
    fill: currentColor !important;
  }
  .svg-icon--checked {
    border-color:currentColor !important;
    background: currentColor !important;
    fill: white !important;
  }
  &:hover,
  &:focus {
    .svg-icon:not(.svg-icon--checked) {
      background: transparent !important;
      fill: currentColor !important;
    }
    .svg-icon--checked {
      border-color: white !important;
      background: white !important;
      /* Only works on secondary buttons */
      fill: #262626 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CheckIcon.vue